export function formatCurrency(value: string | number, currency: string): string {
  const num = typeof value === 'number' ? value : parseFloat(value)
  if (isNaN(num)) return String(value)
  return new Intl.NumberFormat('bg-BG', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(num)
}

// formatPostingAmount renders a Mirage journal line, optionally as a dual
// display when the line crosses currencies: "<foreign> · <base>" with the
// foreign value primary and the base equivalent muted. Falls back to base
// only when no foreign side exists or codes match.
export function formatPostingAmount(p: {
  amount: string
  base_code?: string
  foreign_amount?: string
  foreign_code?: string
}): { primary: string; secondary?: string } {
  const baseCode = p.base_code || 'BGN'
  const base = formatCurrency(p.amount, baseCode)
  if (
    p.foreign_amount &&
    p.foreign_code &&
    p.foreign_code !== baseCode
  ) {
    return {
      primary: formatCurrency(p.foreign_amount, p.foreign_code),
      secondary: base,
    }
  }
  return { primary: base }
}
